import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {
  DVFormArray,
  DVFormControl,
  DVFormGroup
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import * as _ from 'lodash';
@Component({
  selector: 'app-add-experience-price',
  templateUrl: './add-experience-price.component.html',
  styleUrls: ['./add-experience-price.component.css']
})
export class AddExperiencePriceComponent {
  @Input() experienceForm: DVFormGroup;
  constructor() {}
}
